<template>
  <div class="q-header-sub" id="sub" />
</template>

<style lang="sass" scoped>
@import './QHeaderSub'
</style>
